<template>
<div>
    <h1>Login</h1>
    <b-alert :show="this.$root.globalStore.wrongPass" variant="danger">wrong password!</b-alert>
          <label for="inlineFormInputName2">Password</label>
    <b-form inline>
        <b-input v-model="input_password" id="password" type="password"/>
        <b-button variant="primary" @click="register(input_password)" >Log in</b-button>
    </b-form>
</div>
</template>

<script>
import axios from 'axios'
import {store} from '../store' 


export default {
    created(){
        if (localStorage.password) {
        this.register(localStorage.password);
        }
    },
    data(){
    return {
        input_password : '',
        response_status : null,
    }
    },
  methods: { 
      register: function(password){
          let self = this;
          axios.get(self.$root.globalStore.apiUrl + '/login',
          {
            auth: {
                username: 'standard',
                password: password,
            },
          })
          .then(function(response){
            if (response.status == 200) {
                store.data.wrongPass = false;
                localStorage.setItem("password", password);
                store.data.password = password;
                console.log("log in");
                self.$router.push('dashboard');
                } 
          })
          .catch(function(error){
              if(error.response){
                if (error.response.status == 401) {
                  console.log('Status 401, falsches Passwort')
                  store.data.wrongPass = true;
                } else {
                    console.log(error.response);
                }
              }
          })
      }, 
      go(response){
          this.$router.push('edit/1');
      }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/Login.vue